import { compose } from 'redux';
import { connect } from 'react-redux';
import withAuthUser from '../../common/WithAuthUser';
import * as Actions from '../../actions/ProductListOnDisplay';
import ProductListOnDisplay, { Header } from '../../pages/ProductListOnDisplay/ProductListOnDisplay';
import ProductListOnDisplaySelector from '../../selectors/ProductListOnDisplay';
import { getCompanyInfoRequested, getCompanyInfoClear } from '../../actions/OrganizerPosterList';
import { getFavoriteCompaniesRequested, getFavoriteCompaniesClear } from '../../actions/FavoriteCompanies';
import { GetCommonInfoCompanyRequested } from '../../actions/CompanyManagementOrganizer';
import Selector from '../../selectors/OrganizerPosterList';
import { getProductInfoClear, getProductInfoRequested } from '../../actions/ProductManagement';
import { getCountProductRequested } from '../../actions/CartViewer';
import { getSettingCustomTextRequested, getSettingCustomTextClear ,
          getSettingCustomTimerctrlRequest, getSettingCustomTimerctrlClear ,
  } from '../../actions/AdminSettingCustom';

const mapStateToProps = (state) => {
    const productList = ProductListOnDisplaySelector.createSeminarManagementResultsSelector()(state);
    const isLoading = state.registration.registrationViewer.isFetching
        || state.productListOnDisplay.getList.isFetching
        || state.organizerPosterList.getList.isFetching
        || state.productListOnDisplay.sendBusinessCard.isFetching
        || state.productListOnDisplay.companyIds.isFetching
        || state.productListOnDisplay.addToCart.isFetching
        || state.adminSettingCustom.getCustomText.isFetching;
    return {
        locale: state.locale.lang.current,
        productList,
        productListOnDisplay: state.productListOnDisplay.getList.data,
        favoriteCompanyIds: state.favoriteCompanies.get.data.company_ids,
        eventInfo: state.registrationOrganizer.registrationOrganizer.data,
        companies: Selector.createOrganizerPosterListSelector()(state),
        token: state.auth.credential.data.token,
        isLoading,
        product: state.productManagement.getProduct.data,
        companyInfo: state.companyManagementOrganizer.commonInfoCompany.data,
        successSendBusinessCard: state.productListOnDisplay.sendBusinessCard.success,
        companyIds: state.productListOnDisplay.companyIds.data.company_ids,
        viewMode: state.organizerList.viewMode.viewMode,
        companyList: state.organizerPosterList.getList.data.results,
        isWeakAuth: state.auth.credential.data?.isWeakAuth,
        infoAddToCart: state.productListOnDisplay.addToCart,
        customText: state.adminSettingCustom.getCustomText.data?.content,
        customTextPersonInfo: state.adminSettingCustom.getCustomText.data?.content_personal_info,
        customColorExhibitor: state.registrationOrganizer.registrationOrganizer.data?.settings_colors_viewer,
        customTextCompany: state.adminSettingCustom.getCustomText.data?.content_company_organizer,
        customTimerctrl : state.adminSettingCustom.getCustomTimerctrl.data,
    };
};
const mapDispatchToProps = (dispatch) => ({
    getProductListOnDisplay: (prams) => {
        dispatch(Actions.getProductListOnDisplayByCompanyRequested(prams));
    },
    getInformationEvent: (prams) => {
        dispatch(getCompanyInfoRequested({ event: prams.event_name, language: prams.language }));
    },
    getProduct: (companyID, productID) => dispatch(getProductInfoRequested({ companyID, productID })),
    clearGetInformationEvent: () => {
        dispatch(getCompanyInfoClear());
        dispatch(Actions.getProductListOnDisplayByCompanyClear());
        dispatch(getFavoriteCompaniesClear());
        dispatch(getProductInfoClear());
    },
    getFavoriteCompany: (locale) => {
        dispatch(getFavoriteCompaniesRequested({ language: locale }));
    },
    getCommonCompanyInfo: (companyId) => {
        dispatch(GetCommonInfoCompanyRequested(companyId));
    },
    sendBusinessCard: (params) => dispatch(Actions.exchangeBusinessCardRequested(params)),
    clearExchangeBusinessCard: () => {
        dispatch(Actions.clearExchangeBusinessCard());
    },
    getCompanyIdsByEvent: (params) => dispatch(Actions.getCompanyIdsByEventRequested({ ...params })),
    addProductToCart: (params) => dispatch(Actions.addProductsToCartRequested(params)),
    clearAddToCart: () => dispatch(Actions.clearProductsAddToCart()),
    getCount: () => dispatch(getCountProductRequested()),
    getCustomText: (params) => {
        dispatch(getSettingCustomTextRequested(params));
    },
    clearCustomText: () => {
        dispatch(getSettingCustomTextClear());
    },

   getSettingCustomTimerctrl: (params) =>{
    	  dispatch(getSettingCustomTimerctrlRequest(params));
    },
    clearCustomTimerctrl: () =>{
    	  dispatch(getSettingCustomTimerctrlClear() );
    },    
    
});

export const ProductListOnDisplayHeader = connect(mapStateToProps, mapDispatchToProps)(Header);

export default compose(
    withAuthUser,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ProductListOnDisplay);
